export var Status = {
  Happy: 'happy',
  Neutral: 'neutral',
  Sad: 'sad',
  Worried: 'worried'
};